export default {
	login_access_description: 'Sign in with your instance, username, password, or security key.',
	login_access_secure_workspace: 'Access your workspace securely',
	login_add_account: 'Add instance',
	login_cancel: 'Cancel',
	login_data_protection: 'Data protection',
	login_hide_password: 'Hide password',
	login_imprint: 'Imprint',
	login_instance: 'Instance name or URL',
	login_ip_restricted: 'This user is not allowed to sign in from this location.',
	login_login: 'Login',
	login_login_add_webauthn_device: 'Register a new key',
	login_login_webauthn: 'Login with Key',
	login_login_webauthn_validate: 'Validate the Key',
	login_only_letters_for_instance: 'The instance name must consist of numbers and letters only',
	login_password: 'Password',
	login_show_password: 'Show password',
	login_two_factor_authentication_code: '2FA Code',
	login_username: 'Username',
	login_username_or_password_or_2fa_token_wrong: 'Username, password or 2fa code wrong',
	login_username_or_password_wrong: 'Username or password wrong',
	login_valid_instance: 'Instance verified',
	login_validate: 'Check username and password',
	login_validate_failed: 'Failed, check again',
	login_validate_successful: 'Check successful, add account',
	login_webauthn_device_registration_failed: 'The key registration was not successful',
	login_webauthn_device_registration_successful: 'The key registration was successfully performed',
	login_webauthn_help: 'Open security key sign-in help',
};
